
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/guide/sn-2",
      function () {
        return require("private-next-pages/content/guide/sn-2.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/guide/sn-2"])
      });
    }
  